import { iBookingDiscussionItem } from "@sdk/bookings/booking-discussion-item-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectBookingDiscussionItemQueryMap,
  selectEntityMap: selectBookingDiscussionItemsMap,
  selectQueryMapAll: selectBookingDiscussionItemsMapAll,
  selectQueryAllList: selectBookingDiscussionItemsAllList,
  selectAllEntities: selectAllBookingDiscussionItems,
  selectAllEntitiesQuery: selectAllBookingDiscussionItemsQuery,
  selectEntityById: selectBookingDiscussionItemById,
  selectEntityQuery: selectBookingDiscussionItemQuery,
  selectEntityQueryList: selectBookingDiscussionItemQueryList,
} = CreateSelectorForEntities<iStore, iBookingDiscussionItem>({
  sliceName: "bookingDiscussionItems",
});
